import type { ReportTemplate } from '../../schemas';

export const FRONTESPIZIO_SECTIONS: ReportTemplate['sections'] = [
  {
    id: 'sec_societa',
    name: 'Società',
    type: 'static',
    fields: [
      {
        id: 'fld_nome',
        label: 'Nome',
        type: 'text',
        source: '{{company.name}}',
        required: true,
        _idHistory: {
          derivedFrom: 'Nome',
          generatedAt: '2025-12-29T23:08:52.379Z',
        },
      },
      {
        id: 'fld_sede-stabilimento',
        label: 'Sede stabilimento',
        type: 'text',
        source: '{{site.sedeOperativa}}',
        placeholder: 'Via e numero civico',
        _idHistory: {
          derivedFrom: 'Sede stabilimento',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_recapiti-di-invio',
        label: 'Recapiti di invio',
        type: 'text',
        format: 'multiline',
        source: '{{company.reportRecipients}}',
        placeholder: 'Nome Cognome',
        _idHistory: {
          derivedFrom: 'Recapiti di invio',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_nostro-recapito',
        label: 'Nostro recapito',
        type: 'text',
        format: 'email',
        source: '{{variables.nostroRecapito}}',
        _idHistory: {
          derivedFrom: 'Nostro recapito',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_anagrafica',
        label: 'Anagrafica',
        layout: { columns: 1 },
        fieldIds: ['fld_nome', 'fld_sede-stabilimento'],
      },
      {
        id: 'row_recapiti',
        label: 'Recapiti',
        layout: { columns: 1 },
        fieldIds: ['fld_recapiti-di-invio', 'fld_nostro-recapito'],
      },
    ],
    viewBlocks: [
      {
        type: 'grid',
        columns: [
          {
            width: '*',
            blocks: [
              {
                type: 'section-content',
              },
            ],
          },
          {
            width: '34%',
            blocks: [
              {
                type: 'image',
                source: '{{company.logoUrl}}',
                maxWidthCm: 6.2,
                maxHeightCm: 4,
                align: 'center',
                fallbackText: 'Logo non disponibile',
              },
            ],
          },
        ],
      },
    ],
    viewBlocksMode: 'replace',
    disableHighlight: true,
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_periodicita-sopralluoghi',
    name: 'Periodicità sopralluoghi',
    type: 'static',
    fields: [
      {
        id: 'fld_frequenza',
        label: 'Frequenza',
        type: 'text',
        source: '{{ site.schedule.frequencyLabel }}',
        _idHistory: {
          derivedFrom: 'Frequenza',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_periodo-di-controllo',
        label: 'Periodo di controllo',
        type: 'text',
        source: '{{ site.schedule.controlPeriod }}',
        hint: 'Es. 01/2024 - 06/2024',
        _idHistory: {
          derivedFrom: 'Periodo di controllo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_precedente-sopralluogo',
        label: 'Ultimo sopralluogo',
        type: 'date',
        source: '{{ site.schedule.previousVisit }}',
        _idHistory: {
          derivedFrom: 'Ultimo sopralluogo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_prossimo-sopralluogo',
        label: 'Prossimo sopralluogo',
        type: 'text',
        source: '{{ site.schedule.nextVisitDisplay }}',
        disableHighlight: true,
        _idHistory: {
          derivedFrom: 'Prossimo sopralluogo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_data-sopralluogo',
        label: 'Data sopralluogo',
        type: 'date',
        source: '{{ visit.date }}',
        disableHighlight: true,
        editing: {
          state: 'editable',
          reason: 'Il sopralluogo può essere aggiornato direttamente nel report',
        },
        _idHistory: {
          derivedFrom: 'Data sopralluogo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_programmazione',
        label: 'Programmazione',
        fieldIds: [
          'fld_frequenza',
          'fld_periodo-di-controllo',
          'fld_precedente-sopralluogo',
          'fld_prossimo-sopralluogo',
          'fld_data-sopralluogo',
        ],
      },
    ],
    viewBlocks: [],
    disableHighlight: true,
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_impianto',
    name: 'Impianto',
    type: 'static',
    fields: [
      {
        id: 'fld_tipologia',
        label: 'Tipologia',
        type: 'text',
        format: 'multiline',
        source:
          "{{ site.refrigerationUnits | sortBy('location') | map(\"${name}${ammoniaKg | wrap(' (', ' kg)')}: ${impiantoType}${location | wrap(' · ', '')}\") | join('\\n') }}",
        placeholder: 'Sala macchine 1C (1.300 kg): refrigerazione TN acqua glicolata',
        _idHistory: {
          derivedFrom: 'Tipologia',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ubicazione',
        label: 'Ubicazione',
        type: 'text',
        format: 'multiline',
        source: '{{site.locationDescription}}',
        _idHistory: {
          derivedFrom: 'Ubicazione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_gas-tossico',
        label: 'Gas tossico',
        type: 'text',
        source: '{{site.toxicGasLabel}}',
        _idHistory: {
          derivedFrom: 'Gas tossico',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_quantita-autorizzata-kg',
        label: 'Quantità autorizzata (kg)',
        type: 'number',
        source: '{{site.authorization.quantityKg}}',
        formatting: {
          maximumFractionDigits: 0,
        },
        _idHistory: {
          derivedFrom: 'Quantità autorizzata (kg)',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_numero-protocollo',
        label: 'Numero protocollo',
        type: 'text',
        source: '{{site.authorization.protocolNumber}}',
        _idHistory: {
          derivedFrom: 'Numero protocollo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_data-di-rilascio',
        label: 'Data di rilascio',
        type: 'date',
        source: '{{site.authorization.issueDate}}',
        _idHistory: {
          derivedFrom: 'Data di rilascio',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_pubblicazione-su-gazzetta-ufficiale',
        label: 'Pubblicazione su Gazzetta Ufficiale',
        type: 'bool',
        source: '{{site.authorization.gazzetta.published}}',
        formatting: {
          labels: {
            true: 'Si',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'Pubblicazione su Gazzetta Ufficiale',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_data-pubblicazione-g-u',
        label: 'Data pubblicazione G.U.',
        type: 'date',
        source: '{{site.authorization.gazzetta.date}}',
        _idHistory: {
          derivedFrom: 'Data pubblicazione G.U.',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_prescrizioni-autorizzazione',
        label: 'Prescrizioni',
        type: 'text',
        source: '{{site.authorization.prescriptions}}',
        _idHistory: {
          derivedFrom: 'Prescrizioni',
          generatedAt: '2026-01-14T00:00:00.000Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_tipologia',
        label: 'Tipologia',
        fieldIds: ['fld_tipologia'],
      },
      {
        id: 'row_ubicazione',
        label: 'Ubicazione',
        fieldIds: ['fld_ubicazione'],
      },
      {
        id: 'row_gas-tossico',
        label: 'Gas tossico',
        fieldIds: ['fld_gas-tossico'],
      },
      {
        id: 'row_dati-autorizzazione-a-conservare-cus',
        label:
          'Dati Autorizzazione a conservare, custodire e utilizzare gas tossico Ammoniaca Anidra',
        fieldIds: [
          'fld_quantita-autorizzata-kg',
          'fld_numero-protocollo',
          'fld_data-di-rilascio',
          'fld_pubblicazione-su-gazzetta-ufficiale',
          'fld_data-pubblicazione-g-u',
          'fld_prescrizioni-autorizzazione',
        ],
      },
    ],
    viewBlocks: [],
    disableHighlight: true,
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_certificato-prevenzione-incendi',
    name: 'Certificato prevenzione incendi',
    type: 'static',
    fields: [
      {
        id: 'fld_presente',
        label: 'Presente',
        type: 'bool',
        source: '{{site.cpi.present}}',
        formatting: {
          labels: {
            true: 'Presente',
            false: 'Non presente',
          },
        },
        _idHistory: {
          derivedFrom: 'Presente',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_ultimo-rinnovo',
        label: 'Rinnovo/Emissione',
        type: 'date',
        source: '{{site.cpi.lastRenewal}}',
        _idHistory: {
          derivedFrom: 'Rinnovo/Emissione',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_scadenza',
        label: 'Scadenza',
        type: 'date',
        source: '{{site.cpi.expiry}}',
        _idHistory: {
          derivedFrom: 'Scadenza',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
      {
        id: 'fld_presenti-codici-attivita',
        label: 'Presenti codici attività',
        type: 'bool',
        source: '{{site.cpi.ammoniaActivityCodes}}',
        formatting: {
          labels: {
            true: 'Si',
            false: 'No',
          },
        },
        _idHistory: {
          derivedFrom: 'Presenti codici attività',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [
      {
        id: 'row_cpi',
        label: 'CPI',
        fieldIds: [
          'fld_presente',
          'fld_ultimo-rinnovo',
          'fld_scadenza',
          'fld_presenti-codici-attivita',
        ],
      },
    ],
    viewBlocks: [],
    disableHighlight: true,
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
    layout: {
      columns: 2,
    },
  },
  {
    id: 'sec_riferimento-in-caso-di-allarme',
    name: 'Riferimento in caso di allarme',
    type: 'static',
    fields: [
      {
        id: 'fld_referente-allarme',
        label: 'Referente allarme',
        type: 'text',
        source: '{{company.alarmReference.contact}}',
        _idHistory: {
          derivedFrom: 'Referente allarme',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    disableHighlight: true,
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
  },
  {
    id: 'sec_persone-presenti-al-sopralluogo',
    name: 'Persone presenti al sopralluogo',
    type: 'static',
    fields: [
      {
        id: 'fld_partecipanti-sopralluogo',
        label: 'Partecipanti sopralluogo',
        type: 'text',
        format: 'multiline',
        hint: 'Un partecipante per riga',
        required: true,
        editing: {
          state: 'editable',
          reason: 'Seleziona i partecipanti dal personale aziendale',
        },
        _idHistory: {
          derivedFrom: 'Partecipanti sopralluogo',
          generatedAt: '2025-12-29T23:08:52.380Z',
        },
      },
    ],
    rows: [],
    viewBlocks: [],
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
  },
  {
    id: 'sec_personale-patentato',
    name: 'Personale patentato',
    type: 'static',
    fields: [],
    rows: [],
    viewBlocks: [
      {
        type: 'table',
        id: 'tbl_personnel',
        columns: [
          {
            id: 'name',
            label: 'Nome patentato',
            fieldPath: "firstName + ' ' + lastName",
          },
          {
            id: 'licenseExpiry',
            label: 'Scadenza patente',
            fieldPath: "licenseExpiry | date('MM/YYYY','it-IT')",
            align: 'center',
          },
          {
            id: 'licenseLastUpdate',
            label: 'Ultimo aggiornamento',
            fieldPath: "licenseLastUpdate | date('MM/YYYY','it-IT')",
            align: 'center',
          },
          {
            id: 'fireTraining',
            label: 'Corso antincendio',
            fieldPath: "fireTraining | bool('Si','No','N.D.')",
            align: 'center',
          },
          {
            id: 'firstAidTraining',
            label: 'Corso primo soccorso',
            fieldPath: "firstAidTraining | bool('Si','No','N.D.')",
            align: 'center',
          },
        ],
        rowSource: "{{ company.personnel | where('licensed', true) | sortBy('lastName') }}",
        emptyMessage: 'Nessun personale patentato registrato',
        headerStyle: 'bold',
      },
    ],
    navigationGroup: {
      id: 'frontespizio',
      label: 'Società e stabilimento',
      order: 1,
      icon: 'domain',
    },
  },
];
